import React, { FC } from 'react';
import SubmitButton from '../_SubmitButton';
import PrimaryButton, { PrimaryButtonProps } from '../PrimaryButton';

export interface PrimarySubmitButtonProps extends PrimaryButtonProps {}

/**
 * @mode developer
 */
const PrimarySubmitButton: FC<PrimarySubmitButtonProps> = (props) => (
  <SubmitButton
    data-testid="PrimarySubmitButton"
    {...props}
    Button={PrimaryButton}
  />
);

export default PrimarySubmitButton;
